import { render, staticRenderFns } from "./ReadingCenterPage.vue?vue&type=template&id=ebbd83da&"
import script from "./ReadingCenterPage.vue?vue&type=script&lang=js&"
export * from "./ReadingCenterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports